import { Suspense } from 'react';
import ListSkeleton from '../../../../components/molecules/ListSkeleton';
import Header from '../../../../components/organisms/Header';
import DefaultTemplate from '../../../../components/templates/Default';
import StopWordComponent from '../../../../components/pages/StopWord';
import { StopWordType } from '../../../../types/stop-word';

export const StopWordPrePage: React.FC = () => {
  return (
    <DefaultTemplate>
      <Suspense fallback={<ListSkeleton />}>
        <Header currentPageName={'주문자 예측 불용어'}></Header>
        <StopWordComponent type={StopWordType['namepredictor.blacklist']} />
      </Suspense>
    </DefaultTemplate>
  );
};

export default StopWordPrePage;
